<header class="header text-center">
    <img src="assets/images/logo.png" alt="logo">
</header>


<section>
    <div id="main" class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer video-recording">
                    <div class="imageProfile" [style.display]="!recordingFlag?'block':'none'">
                        <video #video id='gum' playsinline autoplay muted width="100%"> </video>
                        <canvas #canvas id="canvas" width="100%"></canvas>
                         <audio id="audioSource" #audioSource  ></audio>
                        <div class="recording active">Recording</div>
                    </div>
                    <div class="imageProfile" *ngIf="recordingFlag">
                        <video id='recorded' playsinline autoplay width="100%"> </video>
                        <!-- <div class="recording">Recording</div> -->
                    </div>

                    <div class="circleBox active" *ngIf="!recordingFlag">
                        <svg width="69" height="69" id="circle" class="progress_svg" style="overflow: visible"
                            xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <circle class="circle_animation" r="34" cy="30" cx="9" stroke-width="5" stroke="#2567e3"
                                    fill="none" />
                            </g>
                        </svg>
                        <span>{{timeLeft}}</span>
                    </div>
                    <p id="question"></p>
                    <p id="answer" style="display: none;">{{answer}}</p>
                    <p *ngIf="recordingFlag">
                        <strong>Hi {{policyHolderName}}</strong><br>
                        Please verify your recorded video with details while submit or cancel your video.
                    </p>
                    <div class="buttonsGroup" *ngIf="recordingFlag">
                        <button type="button" (click)="submit('submit')" class="btn btn-outline-warning">Submit</button>
                        <button type="button" (click)="submit('cancel')"
                            class="btn btn-outline-secondary">Cancel</button>
                    </div>
                    <div id="yesNoBTn" class="buttonsGroup" *ngIf="!recordingFlag">
                        <button type="button" [disabled]="!enableButton" [ngClass]="{'active': questionSubmitBtn}"
                            (click)="nextQuestion('Y')" class="btn btn-outline-warning">Yes</button>
                        <button type="button" [disabled]="!enableButton" [ngClass]="{'active': questionSubmitBtn}"
                            (click)="nextQuestion('N')" class="btn btn-outline-warning">No</button>
                    </div>
                    <!-- <a id="download" (click)="downloadVideo()" download="testFile.webm">Download Video</a> -->
                    <p *ngIf="recordingFlag"><small>Not Satisfied? <a (click)="restartVideo()"> Restart
                                Video</a></small></p>
                    <p *ngIf="!recordingFlag"><small>Take Another Chance? <a (click)="restartVideo()">Restart
                                Video</a></small></p>
                </div>

                <!-- <div class="boxConainer video-recording">
                    <img id="image"/>
                </div> -->
            </div>
        </div>
    </div>
</section>